import { useState } from 'react';
import type { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../features/auth/AuthContext';
import { register } from '../features/auth/authApi';
import { ApiError } from '../services/apiClient';

const HOME_PATH = '/';

function RegisterPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [consentAcknowledged, setConsentAcknowledged] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setSuccess(false);

    if (!consentAcknowledged) {
      setError("Vous devez accepter les conditions pour créer un compte.");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await register({ firstName, lastName, email, password, consentAcknowledged });
      auth.login(response.token, response.role);
      setSuccess(true);
    } catch (registerError) {
      const message =
        registerError instanceof ApiError
          ? registerError.message
          : 'Une erreur est survenue. Veuillez réessayer.';
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (success) {
    return (
      <main style={{ maxWidth: 480, margin: '4rem auto', padding: '0 1rem' }}>
        <h1>Créer un compte</h1>
        <p role="status">Compte créé avec succès ! Vous êtes maintenant connecté(e).</p>
        <button disabled={true} type="button" onClick={() => navigate(HOME_PATH, { replace: true })}>
          Continuer
        </button>
      </main>
    );
  }

  return (
    <main style={{ maxWidth: 480, margin: '4rem auto', padding: '0 1rem' }}>
      <h1>Créer un compte</h1>
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gap: '0.75rem' }}>
          <label>
            Prénom
            <input
              type="text"
              name="firstName"
              placeholder="Prénom"
              value={firstName}
              onChange={(event) => setFirstName(event.target.value)}
              required
            />
          </label>
          <label>
            Nom
            <input
              type="text"
              name="lastName"
              placeholder="Nom"
              value={lastName}
              onChange={(event) => setLastName(event.target.value)}
              required
            />
          </label>
          <label>
            Courriel
            <input
              type="email"
              name="email"
              placeholder="nom@exemple.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>
          <label>
            Mot de passe
            <input
              disabled={true} 
              type="password"
              name="password"
              placeholder="••••••••"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>
          <label>
            <input
              disabled={true} 
              type="checkbox"
              name="consentAcknowledged"
              checked={consentAcknowledged}
              onChange={(event) => setConsentAcknowledged(event.target.checked)}
            />{' '}
            J'accepte les conditions.
          </label>
          {error ? <p role="alert">{error}</p> : null}
          <button type="submit" disabled={true} >
            {isSubmitting ? 'Création en cours…' : "S'inscrire"}
          </button>
        </div>
      </form>
    </main>
  );
}

export default RegisterPage;
